<template>
  <div style="width:100%;float:left;" id="rep_chart_dash">
    <CCard style="height:100%;">
      <CCardHeader color="gradient-success" text-color="white">Rep Sales Last 30 Days</CCardHeader>
      <CCardBody>
        <div style="width:100%;float:left;" v-if="data">
          <CRow>
            <CCol sm="6">
              <CCallout color="success">
                <small class="text-muted">Total $ Sold</small><br>
                <strong class="h4">${{total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</strong>
              </CCallout>
            </CCol>
            <CCol sm="6">
              <CCallout color="danger">
                <small class="text-muted">Total Orders</small><br>
                <strong class="h4">{{totalOrders.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</strong>
              </CCallout>
            </CCol>
          </CRow>
          <CRow>
            <CCol sm="6">
              <div style="width:100%;float:left;" v-if="data" v-for="(val, key) in data">
                <div class="progress-group">
                  <div class="progress-group-header">
                    <span class="title">{{key}}</span>
                    <span class="ml-auto font-weight-bold">
                      ${{val.total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}} <span class="text-muted small">({{parseFloat(configurePercent(val)).toFixed(2)}}%)</span>
                    </span>
                  </div>
                  <div class="progress-group-bars">
                    <CProgress
                      class="progress-xs"
                      :value="configurePercent(val)"
                      color="success"
                    />
                  </div>
                </div>
              </div>
            </CCol>
            <CCol sm="6">
              <div style="width:100%;float:left;" v-if="data" v-for="(val, key) in data">
                <div class="progress-group">
                  <div class="progress-group-header">
                    <span class="title">{{key}}</span>
                    <span class="ml-auto font-weight-bold">
                      {{val.totalOrders.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}} <span class="text-muted small">({{parseFloat(configurePercentOrders(val)).toFixed(2)}}%)</span>
                    </span>
                  </div>
                  <div class="progress-group-bars">
                    <CProgress
                      class="progress-xs"
                      :value="configurePercentOrders(val)"
                      color="danger"
                    />
                  </div>
                </div>
              </div>
            </CCol>
          </CRow>
        </div>
          <!-- <div style="width:30%;float:left;height:75px;">
            <div style="width:100%;float:left;text-align:center;">
              <label style="width:100%;float:left;text-align:center;font-size:.7em;">{{key}}</label>
              <label style="width:100%;float:left;text-align:center;font-size:.7em;">{{val.label}}</label>
            </div>
          </div>
          <div style="width:70%;float:left;height:75px;">
            <label style="width:100%;float:left;text-align:center;">
              ${{val.total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}} ({{parseFloat(configurePercent(val)).toFixed(2)}}%)
            </label>
            <div style="width:100%;float:left;">
              <CProgress
                class="progress-xs"
                :value="configurePercent(val)"
                color="info"
              />
            </div>
          </div> -->
        <!-- </div> -->
        <!-- <div style="width:100%;float:left;" v-if="data">
          <CChartBar
            :datasets="data"
            labels="customers"
          />
        </div> -->
        <small-loader v-else></small-loader>
      </CCardBody>
    </CCard>
  </div>
</template>
<script>
var methods = {}
import { CChartBar } from '@coreui/vue-chartjs'
import {utils} from '@/in_view.js'

methods.getData = function () {
  console.log('get rep chart')
  const postData = {
    csr: this.csr
  }
  axios.post(this.$apiAdress + '/api/reports/rep_30_days?token=' + localStorage.getItem('api_token'), postData).then(response => {
    console.log('reps')
    console.log(response)
    var obj = {}
    this.total = 0
    this.totalOrders = 0
    var that = this
    response.data.forEach(function (val) {
      if (!obj[val.rep_number]) {
        obj[val.rep_number] = {
          label: val.rep.name,
          total: 0,
          totalOrders: 0
        }
      }
      obj[val.rep_number].total += parseFloat(val.price)
      obj[val.rep_number].totalOrders++
      that.total += parseFloat(val.price)
      that.totalOrders++
    })
    this.data = obj
  })
}

methods.configurePercent = function (val) {
  return (parseFloat(val.total) / parseFloat(this.total)) * 100
}

methods.configurePercentOrders = function (val) {
  return (parseFloat(val.totalOrders) / parseFloat(this.totalOrders)) * 100
}

export default {
    // ===Component name
    name: "RepChartDash",
    // ===Props passed to component
    props: ['csr'],
    // ===Components used by this component
    components: {

    },
    // ====component Data properties
    data(){
        return{
          data: null,
          total: 0,
          totalOrders: 0
        }
    },
    // ===Code to be executed when Component is mounted
    mounted() {
      this.getData()
      // var that = this
      // console.log(utils)
      // utils.returnPromise('rep_chart_dash').then(response => {
      //   console.log('response from utils')
      //   console.log(response)
      //   that.getData()
      // })
    },
    destoyed: function(){
      
    },
    // ===Computed properties for the component
    computed: {},
    // ===Component methods
    methods: methods
}
</script>
<!-- styles -->
<!-- adding scoped attribute will apply the css to this component only -->
<style scoped></style>
